/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerAboutMeConfig } from '../../config/header.config';
import { loadingAboutMeConfig } from '../../config/loading.config';
import { errorAboutMeConfig } from '../../config/error.config';
import { notificationsAboutMeConfig } from '../../config/notifications.config';
import { vappContainer } from '@/application';
import { BreadcrumbService } from '@/services/breadcrumbService';
import { policyOptionAboutMeConfig } from '../../config/policy.options.config';

// const getBreadcrumbService = () => {
//   return vappContainer.get<BreadcrumbService>(
//     BreadcrumbService.displayName
//   );
// };

export interface IStaticPageAboutMePluginMethods extends IPluginMethodMap {
  getStaticPageAboutMeSync(args?: any): any;
}

export class StaticPageAboutMePlugin implements IAgentPlugin {
  readonly methods: IStaticPageAboutMePluginMethods;

  constructor() {
    this.methods = {
      getStaticPageAboutMeSync: this.getStaticPageAboutMeSync.bind(this),
    };
  }

  getStaticPageAboutMeSync(args?: any) {
    // const srv = getBreadcrumbService();
    // const breadcrumbItems = srv?.getBreadCrumbItems();
    return {
      header: headerAboutMeConfig,
      loading: loadingAboutMeConfig?.loading,
      error: errorAboutMeConfig,
      notifications: notificationsAboutMeConfig,
      rightBlockContent: policyOptionAboutMeConfig?.policyOption,
    };
  }
}
